<form [formGroup]="form">
  <div id="modelsWrapper">
    <div class="one-column">
        <mat-form-field appearance="fill">
          <mat-label>Producator</mat-label>
          <mat-select formControlName="producer" (selectionChange)="producerChange()" [required]="true">
            <mat-option value="Bilka">
              <div style="display: flex; align-items: center">
                <img height="40" loading="lazy" src="./assets/bilka-logo.svg" />
                <span style="display:none;">Bilka</span>
              </div>
            </mat-option>
            <mat-option value="Wetterbest">
              <div style="display: flex; align-items: center">
                <img height="40" loading="lazy" src="./assets/wetterbest-logo.png" />
                <span style="display:none;">Wetterbest</span>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>

      <ng-container *ngIf="(products | async) as roofs">
        <mat-form-field appearance="fill">
          <mat-label>Model</mat-label>
          <mat-select formControlName="roof" [required]="true" (selectionChange)="modelChange()">
            <mat-option *ngFor="let roof of roofs.results" [value]="roof">
              <div style="display: flex; align-items: center">
                <img height="40" loading="lazy" src="{{getImagePath(roof.type, this.form.controls.producer.value, roof.name, 'lucios', '8017')}}" />
                <span style="font-size: 16px; margin-left: 10px;line-height: 16px">{{roof.name}}</span>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <mat-form-field appearance="fill">
        <mat-label>Finisaj</mat-label>
        <mat-select formControlName="finish" [required]="true" (selectionChange)="finishChange()">
          <mat-option *ngFor="let finish of (finishes$ | async)?.results" [value]="finish">
            <div style="display: flex; align-items: center">
              <img loading="lazy" *ngIf="finish.finish !== 'wood'" height="40"
                   src="{{getImagePath(form.controls.roof.value.type, this.form.controls.producer.value, this.form.controls.roof.value.name, finish.finish, getDefaultFinishColor(finish.finish))}}" />
              <mat-icon *ngIf="finish.finish === 'wood' && form.controls.finish.value.finish !== 'wood'" style="font-size: 40px">
                hide_image
              </mat-icon>
              <span style="font-size: 16px; margin-left: 10px">{{finish.finish | titlecase}}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Grosime</mat-label>
        <mat-select formControlName="thickness" [required]="true" (selectionChange)="thicknessChange()">
          <mat-option *ngFor="let thickness of (thickness$ | async)?.results" [value]="thickness">
            {{thickness.thickness}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Culori</mat-label>
        <mat-select formControlName="color" [required]="true" (selectionChange)="colorChange()">
          <mat-option *ngFor="let color of (colors$ | async)?.results" [value]="color">
            <div style="display: flex; align-items: center">
              <img loading="lazy" *ngIf="form.controls.finish.value.finish !== 'wood'" height="40"
                   src="{{getImagePath(form.controls.roof.value.type, this.form.controls.producer.value, form.controls.roof.value.name, form.controls.finish.value.finish, color.color)}}" />
              <span style="font-size: 16px; margin-left: 10px">{{color.color | titlecase}}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox *ngIf="canApplyDripStop()" (change)="dripstopChange()" style="text-align: left; margin-bottom: 10px; font-size: 16px;" formControlName="hasDripStop" color="primary">
        Aplicare <a target="_blank" href="https://experttabla.ro/blog/membrana-dripstop-bilka/">membrană dripstop</a>
        + {{form.controls.thickness.value.dripStopPrice | discount: form.controls.thickness.value.discount | roncurrency }}/mp
        (minim 40mp)
      </mat-checkbox>

    </div>

    <div *ngIf="imagePath" class="one-column">
      <img alt="Ne pare rău, nu se poate previzualiza acest model" [src]="imagePath" width="245" />
      <ng-container style="display: inline;" *ngIf="form.controls.thickness.value.discount > 0">
        <span class="old-price">{{getFullPrice() | roncurrency}}</span>
        <span
          class="new-price">{{getFullPrice() | discount: form.controls.thickness.value.discount | roncurrency }}
          / {{productType === 'fenceSlats' ? 'ml':'mp'}}</span>
        <em *ngIf="form.controls.thickness.value.discountMinTotal > 0">Reducerea se aplică la comenzi de
          peste {{form.controls.thickness.value.discountMinTotal | roncurrency}}</em>
      </ng-container>
      <ng-container *ngIf="!form.controls.thickness.value.discount">
        <span style="font-weight: 500; font-size: 16px">{{getFullPrice() | roncurrency}} / mp</span>
      </ng-container>
      <ng-container *ngIf="colorWarrantyInYears">
        <span style="font-size: 16px; margin-top: 10px;">Garanție pentru culoare <strong>{{colorWarrantyInYears}} ani</strong>, coroziune <strong>{{corrosionWarrantyInYears}} ani</strong> și durată de viață <strong>{{lifetimeInYears}} ani</strong></span>
        <em style="margin-bottom: 10px;">Variază în funcție de finisaj si grosime.</em>
        <h3 *ngIf="h3" style="font-weight: bold">{{h3}}</h3>
      </ng-container>
    </div>
  </div>

  <step-navigation></step-navigation>
</form>

